<template>
  <div class="costAscription common_group">
    <div class="title">
      <img src="@/assets/images/costIcon.png">
      <span>{{ $t('newApp.Attribute.aoe') }}</span>
      <span class="custom" v-if="$store.state.userInfo.userType === 'rj'"><span
        class="red"
      >{{ $t('general.Note') }}：</span>{{ $t('newApp.Attribute.None') }}</span>
      <span class="custom" v-else><span class="red">{{ $t('general.Note') }}：</span>{{ $t('newApp.Attribute.Ntwo') }}</span>
      <div class="buttonBar">
        <el-button type="primary" @click="addRow" :disabled="isDisabledBtn || $route.path === '/regionReportTransferApplication'">
          {{ $t('newApp.Attribute.aca') }}
        </el-button>
      </div>
    </div>
    <commonTable ref="costAscriptionTable" />
    <!-- :footer-cost="{ label: $t('newApp.Attribute.tc'), val: costTotal.toFixed(2) }"  -->
    <!--    <div class="totalAmount">费用合计（自动生成）：{{ costTotal | costTotalFilter }}</div>-->
    <activityDialog :activity-dialog-visible="activityDialogVisible" :current-row="rowData"
                    @submitHandle="activitySubmitHandle" @dialogCloseHandle="activityDialogClose"
    />
    <advertDialog :advert-dialog-visible="advertDialogVisible" :car-flage-show="ifGoodsEdit" :current-row="rowData"
                  @submitHandle="advertSubmitHandle" @dialogCloseHandle="advertDialogClose"
    />
  </div>
</template>

<script>
import { newApplicationFormApi } from '../../service';
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import activityDialog from '../costAscription/activityDialog';
import advertDialog from '../costAscription/advertDialog';
import { arrayQuery, isNotEmpty } from '@/utils/utils';
import { mapState } from 'vuex';
// import advertCostDetail from './advertCostDetail';
import { bus } from '@/utils/bus';
export default {
  name: 'CostAscription',
  data () {
    return {
      rules: {
          singleActivityExpenseLimit: [
            { required: true, message: `${this.$t('newApp.Attribute.dchdfysxtsy')}`, trigger: 'blur' }
          ],
          perPersonExpenseBudget: [
            { required: true, message: `${this.$t('newApp.Attribute.rjfyystsy')}`, trigger: 'blur' }
          ]
      },
      expenseBudget: {
        singleActivityExpenseLimit: '',
        perPersonExpenseBudget: ''
      },
      tableData: [{}],
      expenseDeptList: [], // 费用归属部门列表
      expenseTypeList: [], // 费用类型列表
      marketList: [], // 细分市场列表,
      productLineList: [], // 产品线列表
      activityDialogVisible: false,
      advertDialogVisible: false,
      rowData: {},
      costTotal: 0.00, // 活动费用总计
      isDisabledBtn: false,
      ifGoodsEdit: false,
      expCode: '',
      allsmartOrderVOList: [],
      addGiftStatus: false,
      timer: null,
      lang: localStorage.getItem('lang') || 'zh-CN',
      financialSystemList: [],
      writeoffCurrency: [],
      templateFinancialSystemList: [],
      templateWriteoffCurrency: [],
      currentFinancialSystem: null,
      remainAvailableAmountList: [] // 行业报备模板费用列表
    };
  },
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    costAscriptionType: {
      type: String,
      default: ''
    },
    componentName: {
      type: String,
      default: ''
    },
    industryReportActivityCode: {
      type: String,
      default: ''
    },
    activitySource: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    ...mapState({
      salerData: (state) => state.newApplication.salerData,
      activityClassification: (state) => state.newApplication.activityClassification
    }),
    calcMax () {
      return (row) => {
        // const dataInfo = this.getRowTemplateCost(row);
        // if (isNotEmpty(dataInfo)) {
        //   // 小池子费用超过单场费用上限那么用单场费用上限额度，没有则用小池子剩余额度
        //   const bigCost = row.budgetLeftAmount > dataInfo.singleActivityExpenseLimit ? dataInfo.singleActivityExpenseLimit : row.budgetLeftAmount;
        //   const smallCost = dataInfo.remainAvailableAmount > dataInfo.singleActivityExpenseLimit ? dataInfo.singleActivityExpenseLimit : dataInfo.remainAvailableAmount;
        //   const singleActivityExpenseLimit = (dataInfo.stat !== 107 ? smallCost * 1 : bigCost) || 0;
        //   const { dataList } = this.$refs.costAscriptionTable.tableData;
        //   const reportApplyAmountList = dataList.map(item => item.reportApplyAmount && row.deptCode === item.deptCode && item.expenseTypeCode === 'EI201' ? item.reportApplyAmount : 0);
        //   const maximumOccupancyCost = reportApplyAmountList.reduce((num, val) => num + val, 0) - (row.reportApplyAmount || 0);
        //   return (singleActivityExpenseLimit - maximumOccupancyCost) > 0 ? singleActivityExpenseLimit - maximumOccupancyCost : 0;
          return 999999999;
        // } else {
        //   return row.budgetLeftAmount * 1 || 999999999;
        // }
      };
    }
  },
  watch: {
    salerData (data) {
      // if (data.editLoadFlage === 2) {
      //   return;
      // }
      if (isNotEmpty(data)) {
        this.getFinancialSystemCommand(data.userId);
      }
      // 如果是编辑页，并且对应销售是初始化数据就不走这里
      // 因为mounted里有table数据初始化，这里会影响到他
      if (this.$route.query.activityCode && this.$store.state.newApplication.salerLoadFlag) return;
      this.deptRelyChangeClear();
    },
    activityClassification () {
      if (this.$route.query.activityCode && this.$store.state.newApplication.activityClassificationLoadFlag) return;
      this.deptRelyChangeClear();
    },
    industryReportActivityCode: {
      handler (val) {
        if (val) {
          this.getQueryRemainAvailableAmount();
        } else {
          this.remainAvailableAmountList = [];
        }
      },
      immediate: true
    }
  },
  filters: {
    costTotalFilter (val) {
      return val.toFixed(2);
    }
  },
  components: {
    commonTable,
    activityDialog,
    advertDialog
    // advertCostDetail
  },
  created () {
    bus.$on('deleteOrdeCodeSuccess', (res) => {
      this.timer = null;
      clearTimeout(this.timer);
      this.findAllsmartOrderVOList(res);
    });
  },
  destroyed () {
    this.timer = null;
    clearTimeout(this.timer);
    // 组件销毁前需要解绑事件。否则会出现重复触发事件的问题
    bus.$off('deleteOrdeCodeSuccess');
  },
  methods: {
    getRowTemplateCost (row) {
      if (this.remainAvailableAmountList.length <= 0 || row.expenseTypeCode !== 'EI201') {
        return null;
      };
      const data = this.remainAvailableAmountList.find(item => row.deptCode === item.deptCode && row.expenseTypeCode === item.expenseTypeCode);
      return isNotEmpty(data) ? data : null;
    },
    isTemplateCost () {
      // 费用归属列表中是否有行业报备模板费用
      if (this.$refs.costAscriptionTable.tableData && this.remainAvailableAmountList.length <= 0) {
        return false;
      }
      const { dataList } = this.$refs.costAscriptionTable.tableData;
      return dataList.some(row =>
        this.remainAvailableAmountList.some(item =>
          row.expenseTypeCode === item.expenseTypeCode && row.deptCode === item.deptCode
        )
      );
    },
    // 获取行业报备模板费用
    getQueryRemainAvailableAmount () {
      const activityCode = this.industryReportActivityCode;
      newApplicationFormApi.queryRemainAvailableAmount(activityCode).then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
            this.remainAvailableAmountList = res.data;
            this.loadTable();
          }
        }
      });
    },
    getFinancialSystemCommand (userId) {
      newApplicationFormApi.getFinancialList(userId).then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
            const result = JSON.parse(JSON.stringify(res.data));
            const templateResult = JSON.parse(JSON.stringify(res.data));
            this.templateFinancialSystemList = templateResult.map(item => {
              item.writeoffCurrency = item.writeoffCurrency.filter(ite => ite.code === 'CNY');
              return item;
            });
            this.templateWriteoffCurrency = this.templateFinancialSystemList[0].writeoffCurrency;
            this.financialSystemList = result;
            this.writeoffCurrency = result[0].writeoffCurrency;
            let { dataList } = this.$refs.costAscriptionTable.tableData;
            if (isNotEmpty(dataList)) {
              dataList.forEach((item, i) => {
                if (i === 0) {
                  let currentEditData = null; // 回显时有数据找出当前数据
                  let currentCreateData = null; // 查询福建数据
                  if (item.financialSystemCode) {
                    currentEditData = this.financialSystemList.find(ite => ite.code === item.financialSystemCode);
                  }
                  const createIndex = this.financialSystemList.findIndex(ite => ite.code === '111');
                  if (createIndex !== -1) {
                    currentCreateData = this.financialSystemList[createIndex];
                  }
                  this.currentFinancialSystem = item.financialSystemCode ? currentEditData.currencyCode : createIndex !== -1 ? currentCreateData.currencyCode : res.data[0].currencyCode;
                  item.financialSystemCode = item.financialSystemCode ? item.financialSystemCode : createIndex !== -1 ? currentCreateData.code : res.data[0].code;
                  item.currencyCode = item.currencyCode ? item.currencyCode : this.writeoffCurrency[0].code;
                  if (this.lang === 'zh-CN') {
                    item.financialSystemName = item.financialSystemName ? item.financialSystemName : createIndex !== -1 ? currentCreateData.shortName : res.data[0].shortName;
                    item.currencyType = item.currencyType ? item.currencyType : this.writeoffCurrency[0].name;
                  } else {
                    item.financialSystemName = item.financialSystemName ? item.financialSystemName : createIndex !== -1 ? currentCreateData.englishShortName : res.data[0].englishShortName;
                    item.currencyType = item.currencyType ? item.currencyType : this.writeoffCurrency[0].code;
                  }
                }
              });
              this.loadTable();
            }
          }
        }
      });
    },
    // 表格每行增加expCode字段
    filterTableListCommand () {
      if (this.$refs.costAscriptionTable) {
        let { dataList } = this.$refs.costAscriptionTable.tableData;
        if (!this.$route.query.activityCode) {
          if (isNotEmpty(dataList)) {
            dataList.forEach((item, i) => {
              if (this.expCode === '') {
                  newApplicationFormApi.getExpCode().then(res => {
                    if (res.status === '200') {
                      item.expCode = res.data;
                      this.expCode = res.data;
                    }
                  });
              } else {
                if (i === 0) {
                    if (!item.expCode) {
                        item.expCode = this.expCode;
                    }
                } else {
                  if (!item.expCode) {
                    newApplicationFormApi.getExpCode().then(res => {
                      if (res.status === '200') {
                        item.expCode = res.data;
                      }
                    });
                  }
                }
              }
            });
          }
        } else {
          dataList.forEach((item, i) => {
            if (!item.expCode) {
              newApplicationFormApi.getExpCode().then(res => {
                if (res.status === '200') {
                  item.expCode = res.data;
                }
              });
            }
          });
        }
      }
    },
    deptRelyChangeClear () {
      this.tableData = [{}];
      this.expenseTypeList = [];
      this.marketList = [];
      this.productLineList = [];
      this.getFinancialSystemCommand(this.salerData.userId);
      this.loadTable();
    },
    validateHandler () {
      if (this.tableData.length < 1) {
        this.$message.error(this.$t('newApp.Attribute.psca'));
        return;
      }
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i];
        if (this.singleActivityExpenseLimit) {
          const reportApplyAmountList = this.tableData.map(item => item.reportApplyAmount && item.expenseTypeCode === 'EI201' ? item.reportApplyAmount : 0);
          const maximumOccupancyCost = reportApplyAmountList.reduce((num, val) => num + val, 0);
          if (maximumOccupancyCost > this.singleActivityExpenseLimit) {
            this.$message.error(`${item.deptName}` + this.$t('newApp.Attribute.tao'));
            return;
          }
        }
        // 如果是转申请，费用可以调整，但不能大于报备金额
        const reportType = this?.editEchoData?.marketActivity?.reportType ? this?.editEchoData?.marketActivity?.reportType * 1 : 0;
        if (this.$route.path === '/regionReportTransferApplication' || (reportType > 0)) {
          let groupToatal = Number(item.activityCost) + Number(item.advertisingCost);
          if (groupToatal > item.reportApplyAmount) {
            this.$message.error(`${item.deptName}` + this.$t('newApp.Attribute.tao'));
            return;
          }
        }
        if (!item.financialSystemCode) {
          this.$message.error(this.$t('newApp.BasicInfo.psafs'));
          return;
        }
        if (!item.currencyCode) {
          this.$message.error(this.$t('newApp.BasicInfo.psac'));
          return;
        }
        if (!item.deptCode) {
          this.$message.error(this.$t('newApp.Attribute.pstcad'));
          return;
        }
        if (!item.expenseTypeCode) {
          this.$message.error(this.$t('newApp.Attribute.psaft'));
          return;
        }
        if (!item.subMarketCode) {
          this.$message.error(this.$t('newApp.Attribute.psams'));
          return;
        }
        if (item.deptCode.indexOf('000013') === 0 && !item.productLine) {
          this.$message.error(this.$t('newApp.Attribute.bppsapl'));
          return;
        }
      }
      return true;
    },
    addRow () {
      this.$refs.costAscriptionTable.insertRow();
      this.$refs.costAscriptionTable.refreshColumn();
      this.filterTableListCommand();
    },
    deleteBtn (row) {
      const { activityCode } = this.$store.state.newApplication;
      let params = {
        eventCode: row.activityCode || this.$route.query.activityCode || activityCode,
        expCode: row.expCode
      };
      if (row.advertisingCost) {
        newApplicationFormApi.deleteExpense(params).then(res => {
          if (res.status === '200') {
            this.$message.success('删除成功');
            this.timer = null;
            clearTimeout(this.timer);
            this.$refs.costAscriptionTable.removeRow(row);
            this.setCostTotal();
          }
        });
      } else {
        this.$refs.costAscriptionTable.removeRow(row);
        this.setCostTotal();
      }
    },
    activityDialogClose () {
      this.activityDialogVisible = false;
    },
    activitySubmitHandle (val) {
      if (this.$store.state.newApplication.editFlag !== 2) {
        let total = Number(val.total);
        this.$refs.costAscriptionTable.reviseRow(this.rowData, {
          activityCost: total.toFixed(2),
          activityExpenseDetails: val.list,
          expenseDetailNote: val.describe
        });
        this.setCostTotal();
        this.activityDialogVisible = false;
      } else {
        this.$message.error(this.$t('newApp.Attribute.ffna'));
      }
    },
    activityCostBtn (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.activityDialogVisible = true;
    },
    // 费用归属总计页面设置
    setCostTotal () {
      this.costTotal = this.editEchoData && this.$route.path === '/regionReportTransferApplication' ? this.getCostTotal() : this.getReportApplyAmount();
    },
    // 报备金额总计
    getReportApplyAmount () {
      const costTotal = this.tableData.reduce((current, item) => {
        const reportApplyAmount = item.reportApplyAmount ? Number(item.reportApplyAmount) : 0;
        return current + reportApplyAmount;
      }, 0);
      return costTotal;
    },
    // 费用归属总计
    getCostTotal () {
      const costTotal = this.tableData.reduce((current, item) => {
        let activeityCost = item.activityCost ? Number(item.activityCost) : 0;
        let advertCost = item.advertisingCost ? Number(item.advertisingCost) : 0;
        return current + activeityCost + advertCost;
      }, 0);
      return costTotal;
    },
    advertCostBtn (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.ifGoodsEdit = row.advertiseExpenseDetails && row.advertiseExpenseDetails.advertiseOrderDetails.length > 0;
      this.advertDialogVisible = true;
    },
    findAllsmartOrderVOList (res) {
      this.timer = null;
      clearTimeout(this.timer);
      if (this.$refs.costAscriptionTable) {
        const { dataList } = this.$refs.costAscriptionTable.tableData;
        dataList.forEach(item => {
          this.getDetailCommand(item);
        });
        if (!res) {
          this.timer = setTimeout(() => {
            this.findAllsmartOrderVOList();
          }, 5000);
        }
      }
    },
    goToNewLink (row) {
      if (!this.addGiftStatus) {
        this.findAllsmartOrderVOList();
        this.addGiftStatus = true;
      }
      const { activityCode } = this.$store.state.newApplication;
      const { sysUser } = this.$store.state.userInfo;
      const eventcode = row.activityCode || this.$route.query.activityCode || activityCode;
      const expensecode = row.expCode;
      const rjPercode = sysUser.userId;
      const params = {
        method: 'gift_select',
        reqData: `<?xml version="1.0" encoding="utf-8"?><body><eventcode>${eventcode}</eventcode><expensecode>${expensecode}</expensecode><rj_percode>${rjPercode}</rj_percode><lang>${this.lang === 'zh-CN' ? 'zh_cn' : 'en_us'}</lang></body>`,
        lang: this.lang === 'zh-CN' ? 'zh_cn' : 'en_us'
      };
      newApplicationFormApi.getGiftUrl(params).then(res => {
        if (res.status === '200') {
          window.open(res.data);
        }
      });
    },
    async getDetailCommand (row, type) {
      const { activityCode } = this.$store.state.newApplication;
      let params = {
        eventCode: row.activityCode || activityCode || this.$route.query.activityCode, // 'RJM2302080123'
        expCode: row.expCode // '3021b17a55de44d1a0f00f542624001c'
      };
      newApplicationFormApi.getDetailsAll(params).then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
            const { orderlist } = res.data;
            const odrAmount = orderlist.map(item => item.odrAmount * 1).reduce((x, y) => x + y);
            row.advertisingCost = odrAmount;
            if (row.advertisingCost > 0) {
                if (row.currencyCode !== 'CNY') {
                  const currentData = this.writeoffCurrency.find(item => {
                    return item.code === 'CNY';
                  });
                  row.currencyCode = currentData.code;
                  row.currencyType = currentData.name;
                }
            }
            this.loadTable();
            let allsmartOrderVOList = [];
            orderlist.forEach(item => {
              allsmartOrderVOList.push({
                prodCode: item.odrCode,
                expCode: row.expCode,
                odrAmount: item.osubList.map(ite => ite.osub_amount * 1).reduce((x, y) => x + y),
                productList: item.osubList.map(ite => {
                  const params = {
                    productName: ite.productName,
                    prodId: ite.prodid,
                    unitprice: ite.unitprice,
                    buynum: ite.buynum,
                    osubAmount: ite.osub_amount
                  };
                  return params;
                })
              });
            });
            row.allsmartOrderVOList = allsmartOrderVOList;
            if (type === 'submit') {
              this.$emit('checkAllsmartOrderVOListCommand');
            } else if (type === 'save') {
              this.$emit('checkAllsmartOrderVOListSaveCommand');
            }
          } else {
            row.advertisingCost = 0;
            row.allsmartOrderVOList = [];
            this.loadTable();
            if (type === 'submit') {
              this.$emit('checkAllsmartOrderVOListCommand');
            } else if (type === 'save') {
              this.$emit('checkAllsmartOrderVOListSaveCommand');
            }
          }
        }
      }).catch(() => {
          if (type === 'submit') {
            this.$emit('checkAllsmartOrderVOListCommand');
          } else if (type === 'save') {
            this.$emit('checkAllsmartOrderVOListSaveCommand');
          }
      });
    },
    advertSubmitHandle (val) {
      if (this.$store.state.newApplication.editFlag !== 2) {
        this.$refs.costAscriptionTable.reviseRow(this.rowData, {
          advertisingCost: val.total,
          advertiseExpenseDetails: {
            ...val.formData,
            totalMoney: val.total,
            advertiseOrderDetails: val.goodsList
          }
        });
        this.setCostTotal();
        this.advertDialogVisible = false;
      } else {
        this.$message.error(this.$t('newApp.Attribute.ndc'));
      }
    },
    advertDialogClose () {
      this.advertDialogVisible = false;
    },
    isShowProductLine () {
      return this.tableData.some(item => {
        if (item.deptCode) {
          return item.deptCode.indexOf('000013') === 0;
        } else {
          return false;
        }
      });
    },
    getExpenseDeptList (code, editFlag) {
      let path = this.$route.path;
      let params = {
        deptCode: code || this.salerData.deptCode,
        activityClassification: this.activityClassification,
        activityType: path === '/regionReportApplication' || path === '/editRegionReportApplication' ? 2 : 1,
        reportType: 1
      };
      newApplicationFormApi.getExpenseDeptList(params).then(res => {
        if (res.status === '200') {
          this.expenseDeptList = res.data ? res.data : [];
          if (editFlag && this.expenseDeptList.length > 0) {
            // 编辑回显获取费用归属部门里的费用类型列表
            this.tableData.map(item => {
              if (item.deptCode) {
                let deptObj = arrayQuery(item.deptCode, this.expenseDeptList, 'deptCode');
                // 如果找到了，则直接将对应的费用类型过滤并赋值
                if (deptObj) {
                  item.expenseTypeList = this.filterExpenseTypeList(deptObj.expenseTypeList);
                } else {
                  // 没有找到，则说明没有权限，费用归属部门列表中没有该deptCode
                  // 为了处理报错则手动追加一个
                  this.expenseDeptList.push({
                    deptCode: item.deptCode,
                    deptName: item.deptName
                  });
                  item.expenseTypeList = [];
                }
              }
              return item;
            });
          }
          this.$refs.costAscriptionTable.refreshColumn();
          this.loadTable();
        }
      });
    },
    filterExpenseTypeList (typeList) {
      if (typeList && typeList.length > 0) {
        // 如果是渠道不做任何處理
        if (this.$store.state.userInfo.userType === 'qd') {
          return typeList;
        }
        // 不是联合市场活动 && 对应销售为smb部门
        if (!this.$store.state.newApplication.isUnionMarket && this.salerData.belongToSmb) {
          return typeList.filter(item => {
            // 过滤1： 如果没有选择渠道签约类型且对应销售属于smb部门，则费用类型中不包括SMB区域市场基金
            if (item.expenseTypeName !== this.$t('newApp.Attribute.srmf')) {
              return item;
            }
          });
        }
        // 过滤2： 如果活动分类不是区域模板活动或区域参与总部活动，则费用类型中不包括营销费用-模板活动
        if (this.activityClassification !== 'AC_01' && this.activityClassification !== 'AC_03') {
          return typeList.filter(item => {
            if (item.expenseTypeName !== this.$t('newApp.Attribute.metc')) {
              return item;
            }
          });
        }
        // 如果都不满足以上两条过滤条件则之间返回全部费用类型
        return typeList;
      }
    },
    getMarketList (code) {
      newApplicationFormApi.getMarketList(code).then(res => {
        if (res.status === '200') {
          this.marketList = res.data;
          this.loadTable();
        }
      });
    },
    getProductLineList () {
      newApplicationFormApi.getProductLineList().then(res => {
        if (res.status === '200') {
          this.productLineList = res.data;
          this.loadTable();
        }
      });
    },
    moneyCount (row) {
      row.price = row.price ? Number(row.price) : 0;
      row.amount = row.amount ? Number(row.amount) : 0;
      row.total = row.price * row.amount;
      this.totalMoney = this.tableData.reduce((current, item) => {
        return current + item.total;
      }, 0);
    },
    loadTable () {
      let tableRow = new TableRow();
      // 财务体系
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.BasicInfo.fs'))
          ._data('financialSystemCode')
          ._width('10%')
          ._cellType('customSelect')
          ._cellData({
            options: this.financialSystemList,
            disabled: ({ row, column }) => {
            },
            optionProps: {
              label: this.lang === 'zh-CN' ? 'shortName' : 'englishShortName',
              value: 'code'
            },
            events: {
              focus: ({ row }) => {
                  if (isNotEmpty(row.expenseTypeList)) {
                      this.expenseTypeList = this.filterExpenseTypeList(row.expenseTypeList);
                  }
                  this.loadTable();
              },
              change: ({ row }) => {
                const currentData = this.financialSystemList.find(item => {
                  return item.code === row.financialSystemCode;
                });
                this.currentFinancialSystem = currentData.currencyCode;
                row.financialSystemName = this.lang === 'zh-CN' ? currentData.shortName : currentData.englishShortName;
                if (row.expenseType) {
                    let expenseTypeObj = arrayQuery(row.expenseType, this.expenseTypeList, 'expenseTypeName');
                    row.expenseTypeCode = expenseTypeObj.expenseTypeCode;
                    let params = {
                      deptCode: row.deptCode,
                      expenseTypeCode: row.expenseTypeCode,
                      currentFinancialSystem: this.currentFinancialSystem,
                      localCurrencyCode: row.currencyCode
                    };
                    newApplicationFormApi.getRealBudgetBalance(params).then(res => {
                      if (res.status === '200') {
                        row.budgetLeftAmount = res.data.toFixed(2);
                        this.$refs.costAscriptionTable.refreshColumn();
                      }
                    });
                }
                this.$refs.costAscriptionTable.refreshColumn();
              }
            }
          })
      );
      // 货币种类
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.BasicInfo.toc'))
          ._data('currencyCode')
          ._width('10%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              // 区域使用行业报备过的模版时 货币种类下拉选只有人民币
              const writeoffCurrency = this.getRowTemplateCost(row) ? this.templateWriteoffCurrency : this.writeoffCurrency;
              return (
                <el-select
                  v-model={row[column.property]}
                  placeholder={this.$t('general.ps')}
                  disabled={row['advertisingCost'] > 0}
                  onFocus={() => {
                    if (isNotEmpty(row.expenseTypeList)) {
                      this.expenseTypeList = this.filterExpenseTypeList(row.expenseTypeList);
                    }
                    this.loadTable();
                  }}
                  onChange={() => {
                    const currentData = this.writeoffCurrency.find(item => {
                      return item.code === row.currencyCode;
                    });
                    row.currencyType = this.lang === 'zh-CN' ? currentData.name : currentData.code;
                    if (row.expenseType) {
                        let expenseTypeObj = arrayQuery(row.expenseType, this.expenseTypeList, 'expenseTypeName');
                        row.expenseTypeCode = expenseTypeObj.expenseTypeCode;
                        let params = {
                          deptCode: row.deptCode,
                          expenseTypeCode: row.expenseTypeCode,
                          currentFinancialSystem: this.currentFinancialSystem,
                          localCurrencyCode: row.currencyCode
                        };
                        newApplicationFormApi.getRealBudgetBalance(params).then(res => {
                          if (res.status === '200') {
                            row.budgetLeftAmount = res.data.toFixed(2);
                            this.$refs.costAscriptionTable.refreshColumn();
                          }
                        });
                    }
                    this.$refs.costAscriptionTable.refreshColumn();
                  }}
                >
                  {
                    writeoffCurrency.map(item => (
                      <el-option
                        key={item.code}
                        label={this.lang === 'zh-CN' ? item.name : item.code}
                        value={item.code}
                      />
                    ))
                  }
                </el-select>
              );
            }
          })
      );
      // 费用归属部门
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.cad'))
          ._data('deptCode')
          ._width('12%')
          ._cellType('customSelect')
          ._cellData({
            options: this.expenseDeptList,
            disabled: ({ row, column }) => {
              if (this.$route.path === '/regionReportTransferApplication' || this.$route.path === '/editRegionReportApplication') return true;
              return row.allowEdit === false && this.$store.state.newApplication.editFlag !== 0;
            },
            optionProps: {
              label: 'deptName',
              value: 'deptCode'
            },
            events: {
              focus: () => {
                if (!this.salerData.deptCode) {
                  this.$message.error(this.$t('newApp.BasicInfo.pstcs'));
                  return;
                }
                let path = this.$route.path;
                let params = {
                  deptCode: this.salerData.deptCode,
                  activityClassification: this.activityClassification,
                  activityType: path === '/regionReportApplication' || path === '/editRegionReportApplication' ? 2 : 1,
                  reportType: 1
                };
                if (this.industryReportActivityCode) {
                  params.activitySource = this.activitySource;
                  params.activityCode = this.industryReportActivityCode;
                }
                newApplicationFormApi.getExpenseDeptList(params).then(res => {
                  if (res.status === '200') {
                    // 如果登录人是smb的渠道，则过滤掉SMB事业部
                    if (this.$store.state.userInfo.userType === 'qd' && this.$store.state.userInfo.belongToSmb) {
                      this.expenseDeptList = res.data ? res.data.filter(item => {
                        return item.deptCode !== '000063';
                      }) : [];
                    } else {
                      this.expenseDeptList = res.data ? res.data : [];
                    }
                    this.loadTable();
                  }
                });
              },
              change: ({ row, column }) => {
                // 如果选择品牌推广部就获取产品线列表
                if (this.isShowProductLine()) {
                  this.getProductLineList();
                }
                let deptObj = arrayQuery(row.deptCode, this.expenseDeptList, 'deptCode');
                row.deptName = deptObj.deptName;
                row.expenseTypeList = deptObj.expenseTypeList;
                // 费用类型清空
                row.expenseTypeCode = '';
                row.expenseType = '';
                // 预算金额清空
                if (this.$store.state.userInfo.userType === 'rj') {
                  row.budgetLeftAmount = '';
                }
                // 细分市场清空
                row.subMarketCode = '';
                row.subMarket = '';
                // 产品线清空
                row.productLine = '';
                // 活动费用重置为0
                row.activityCost = 0;
                // 报备金额清空
                row.reportApplyAmount = 0;
                this.setCostTotal();
                // 如果是渠道smb并且费用类型列表中含有smb市场区域基金，则默认选中smb市场区域基金
                if (this.$store.state.userInfo.userType === 'qd' && this.$store.state.userInfo.belongToSmb) {
                  let smbMarketFundObj = row.expenseTypeList.find(item => {
                    return item.expenseTypeCode === 'EI172';
                  });
                  if (smbMarketFundObj && Object.keys(smbMarketFundObj).length > 0) {
                    row.expenseTypeCode = smbMarketFundObj.expenseTypeCode;
                    row.expenseType = smbMarketFundObj.expenseTypeName;
                    let params = {
                      deptCode: row.deptCode,
                      expenseTypeCode: row.expenseTypeCode
                    };
                    // 默认选中费用类型后，请求预算余额
                    newApplicationFormApi.getBudgetBalance(params).then(res => {
                      if (res.status === '200') {
                        row.budgetLeftAmount = res.data.realBudget.toFixed(2);
                      }
                    });
                  }
                }
                const { dataList } = this.$refs.costAscriptionTable.tableData;
                bus.$emit(this.costAscriptionType, dataList);
                this.$refs.costAscriptionTable.refreshColumn();
                this.loadTable();
              }
            }
          })
      );
      // 费用类型
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.toe'))
          ._data('expenseType')
          ._width('12%')
          ._cellType('customSelect')
          ._cellData({
            options: this.expenseTypeList,
            disabled: ({ row, column }) => {
              if (this.$route.path === '/regionReportTransferApplication' || this.$route.path === '/editRegionReportApplication') return true;
              return row.allowEdit === false && this.$store.state.newApplication.editFlag !== 0;
            },
            optionProps: {
              label: 'expenseTypeName',
              value: 'expenseTypeName'
            },
            events: {
              focus: ({ row }) => {
                if (!row.deptCode) {
                  this.$message.error(this.$t('newApp.Attribute.pstcad'));
                  this.expenseTypeList = [];
                  this.loadTable();
                } else {
                  this.expenseTypeList = this.filterExpenseTypeList(row.expenseTypeList);
                  this.loadTable();
                }
              },
              change: ({ row }) => {
                let expenseTypeObj = arrayQuery(row.expenseType, this.expenseTypeList, 'expenseTypeName');
                row.expenseTypeCode = expenseTypeObj.expenseTypeCode;
                // 区域使用行业报备过的模版时 货币种类默认选择人民币
                if (this.getRowTemplateCost(row)) {
                  if (row.currencyCode !== 'CNY') {
                    row.currencyCode = 'CNY'; // 默认选择人民币
                    // 区域使用行业报备过的模版时 货币种类下拉选只有人民币
                    const writeoffCurrency = this.getRowTemplateCost(row) ? this.templateWriteoffCurrency : this.writeoffCurrency;
                    const currentData = writeoffCurrency.find(item => {
                      return item.code === row.currencyCode;
                    });
                    row.currencyType = this.lang === 'zh-CN' ? currentData.name : currentData.code;
                  }
                }
                let params = {
                  deptCode: row.deptCode,
                  expenseTypeCode: row.expenseTypeCode,
                  currentFinancialSystem: this.currentFinancialSystem,
                  localCurrencyCode: row.currencyCode
                };
                newApplicationFormApi.getRealBudgetBalance(params).then(res => {
                  if (res.status === '200') {
                    row.budgetLeftAmount = res.data.toFixed(2);
                    this.$refs.costAscriptionTable.refreshColumn();
                  }
                });
                const { dataList } = this.$refs.costAscriptionTable.tableData;
                bus.$emit(this.costAscriptionType, dataList);
                this.loadTable();
              }
            }
          })
      );
      // 单场费用上限
      if (this.remainAvailableAmountList.length > 0 && this.isTemplateCost()) {
        tableRow.push(
          new TableColumns()
            ._title('industryReport.hybblb.list.fyyq')
            ._data('singleActivityExpenseLimit')
            ._align('right')
            ._width('9%')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                row.singleActivityExpenseLimit = (this.getRowTemplateCost(row)) ? this.getRowTemplateCost(row).singleActivityExpenseLimit : 0;
                return (
                  <span>{row.singleActivityExpenseLimit || '-'}</span>
                );
              }
            })
        );
      }
      // 预算余额
      if (this.$store.state.userInfo.userType === 'rj') {
        tableRow.push(
          new TableColumns()
            ._title(this.$t('newApp.Attribute.bb'))
            ._data('budgetLeftAmount')
            ._align('right')
            ._width('9%')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <span>{row.budgetLeftAmount}</span>
                );
              }
            })
        );
      }
      // 细分市场
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.ms'))
          ._data('subMarketCode')
          ._width('12%')
          ._cellType('customSelect')
          ._cellData({
            options: this.marketList,
            disabled: ({ row, column }) => {
              if (this.$route.path === '/regionReportTransferApplication') return true;
              return row.allowEdit === false && this.$store.state.newApplication.editFlag !== 0;
            },
            optionProps: {
              label: 'marketSegment',
              value: 'marketSegment'
            },
            events: {
              focus: ({ row }) => {
                if (!row.deptCode) {
                  this.$message.error(this.$t('newApp.Attribute.pstcad'));
                  this.marketList = [];
                  this.loadTable();
                } else {
                  this.getMarketList(row.deptCode);
                }
              },
              change: ({ row }) => {
                let subMarketObj = arrayQuery(row.subMarketCode, this.marketList, 'marketSegment');
                row.subMarket = subMarketObj.marketSegment;
                this.$refs.costAscriptionTable.refreshColumn();
              }
            }
          })
      );
      // 产品线
      if (this.isShowProductLine()) {
        tableRow.push(
          new TableColumns()
            ._title(this.$t('newApp.Attribute.pl'))
            ._data('productLine')
            ._width('12%')
            ._cellType('customSelect')
            ._cellData({
              options: this.productLineList,
              disabled: ({ row, column }) => {
                return row.allowEdit === false && this.$store.state.newApplication.editFlag !== 0;
              },
              optionProps: {
                label: 'fieldValue',
                value: 'fieldValue'
              },
              events: {
                change: ({ row }) => {
                  this.$refs.costAscriptionTable.refreshColumn();
                }
              }
            })
        );
      }
      // 报备金额
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.bbje'))
          ._data('reportApplyAmount')
          ._width('8%')
          ._align('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              const maxVal = Number(this.calcMax(row)) || 0;
              return (
                <el-input-number
                  v-model={row[column.property]}
                  disabled={(row.allowEdit === false && this.$store.state.newApplication.editFlag !== 0)}
                  min={0}
                  max={maxVal}
                  precision={2}
                  controls={false}
                  class="activity-input"
                  onChange={(newVal, oldVal) => {
                    // clamp 并写回 row，确保其他依赖能读到最新值
                    const clamped = newVal > maxVal ? maxVal : (newVal < 0 ? 0 : newVal);
                    // 保证响应式赋值
                    this.$set(row, column.property, Number(clamped));
                    this.setCostTotal();
                    this.$refs.costAscriptionTable && this.$refs.costAscriptionTable.refreshColumn();
                  }}
                />
              );
            }
          })
      );
      if (this.$route.path === '/regionReportTransferApplication') {
        // 活动费用
        tableRow.push(
          new TableColumns()
            ._title(this.$t('newApp.Attribute.ac'))
            ._data('activityCost')
            ._width('8%')
            ._align('left')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <el-button
                    className="vxe_editDialog"
                    disabled={row.allowEdit === false && this.$store.state.newApplication.editFlag !== 0}
                    type="text"
                    onClick={() => {
                      this.activityCostBtn(row);
                    }}
                  >
                    {row.activityExpenseDetails && row.activityExpenseDetails.length > 0 ? row[column.property] : this.$t('btn.Add')}
                  </el-button>
                );
              }
            })
        );
        // 广告品费用
        tableRow.push(
          new TableColumns()
            ._title(this.$t('newApp.Attribute.coam'))
            ._data('advertisingCost')
            ._width('12%')
            ._align('right')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                let isDisabled = false;
                // 如果是编辑页，并且没有权限，则不能编辑
                if (row.allowEdit === false && this.$store.state.newApplication.editFlag !== 0) {
                  isDisabled = true;
                }
                // 如果是渠道则不能添加广告品
                if (this.$store.state.userInfo.userType.indexOf('qd') === 0) {
                  isDisabled = true;
                }
                // 如果是报备申请或者报备编辑则不能添加广告品
                if (this.$route.path === '/reportApplication' || this.$route.path === '/editReportApplication') {
                  isDisabled = true;
                }
                // 当前币种不是人民币不能添加广告品
                if (row.currencyCode !== 'CNY') {
                  isDisabled = true;
                }
                return (
                    <div class="add-dialog">
                        <el-popover
                          placement="top-start"
                          title={this.$t('newApp.Attribute.breakdownAdvertising')}
                          width="900"
                          trigger="hover"
                          disabled={!isNotEmpty(row.allsmartOrderVOList)}
                          >
                          <advertCostDetail
                            row-data={row.allsmartOrderVOList}
                            activityCode={row.activityCode || this.$store.state.newApplication.activityCode || this.$route.query.activityCode}></advertCostDetail>
                          <el-button
                            className="vxe_editDialog"
                            disabled={ isDisabled }
                            type="text"
                            slot="reference"
                            onClick={() => {
                              this.goToNewLink(row);
                            }}
                          >
                            { row['advertisingCost'] || this.$t('btn.Add')}
                          </el-button>
                        </el-popover>
                    </div>
                );
              }
            })
        );
        // 申请金额
        tableRow.push(
          new TableColumns()
            ._title(this.$t('newApp.Attribute.aa'))
            ._data('applyAmount')
            ._width('12%')
            ._align('right')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                let activityCost = row.activityCost ? Number(row.activityCost) : 0;
                let advertCost = row.advertisingCost ? Number(row.advertisingCost) : 0;
                row[column.property] = activityCost + advertCost;
                return (
                  <span>{row[column.property].toFixed(2)}</span>
                );
              }
            })
        );
      }
      // 备注
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Remarks'))
          ._data('note')
          ._width('12%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-input
                  v-model={row[column.property]}
                  disabled={row.allowEdit === false && this.$store.state.newApplication.editFlag !== 0}
                  maxlength="500"
                />
              );
            }
          })
      );
      // 操作
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('7%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.deleteBtn(row);
                  }} disabled={this.isDisabledBtn || this.$route.path === '/regionReportTransferApplication'}> { this.$t('btn.Delete') }
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        if (this.$refs.costAscriptionTable) {
          this.$refs.costAscriptionTable.setColumn(column, {
            page: false
          });
          this.$refs.costAscriptionTable.loadStaticTable(this.tableData);
        }
        this.filterTableListCommand();
      });
    },
    handleChange (value) {
        console.log(value);
    },
    advertCloseHandle () {
      this.advertCostNewDialogVisible = false;
    }
  },
  mounted () {
    this.isDisabledBtn = this.$store.state.newApplication.editFlag === 2;

    if (this.$route.query.activityCode) {
      // 编辑回显处理
      let oldAdvertiseFlag = false;
      if (this.$store.state.newApplication.editFlag === 1 || this.$store.state.newApplication.editFlag === 3) {
        // 可编辑
        let tableListData = [];
        this.editEchoData.mactExpenseBelongVOList.forEach(item => {
          if (item.allowEdit && item.mactExpenseBelong.deptName !== this.$t('newApp.Attribute.roha')) {
            let returnVal = {
              ...item.mactExpenseBelong,
              allowEdit: item.allowEdit
            };
            returnVal.activityExpenseDetails = item.activityExpenseDetails;
            // 判断广告品是否是旧的广告品，如果是旧的，则清空
            if (isNotEmpty(item.advertiseExpenseDetails) && item.advertiseExpenseDetails.suppliers === 'srm') {
              oldAdvertiseFlag = true;
              item.advertiseExpenseDetails = null;
              // 广告品费用清0
              returnVal.advertisingCost = 0;
            } else {
              item.advertiseExpenseDetails = null;
            }
            returnVal.advertiseExpenseDetails = {
              ...item.advertiseExpenseDetails,
              advertiseOrderDetails: item.advertiseExpenseDetails ? item.advertiseExpenseDetails.advertiseOrderDetails : []
            };
            returnVal.allsmartOrderVOList = item.allsmartOrderVOList;
            tableListData.push(returnVal);
          }
        });
        this.tableData = tableListData;
        this.loadTable();
      } else {
        // 不可编辑
        let tableListData = [];
        this.editEchoData.mactExpenseBelongVOList.forEach(item => {
          if (item.mactExpenseBelong.deptName !== this.$t('newApp.Attribute.roha')) {
            let returnVal = {
              ...item.mactExpenseBelong
            };
            returnVal.allowEdit = item.allowEdit;
            returnVal.activityExpenseDetails = item.activityExpenseDetails;
            this.allsmartOrderVOList = item.allsmartOrderVOList;
            // 判断广告品是否是旧的广告品，如果是旧的，则清空
            if (isNotEmpty(item.advertiseExpenseDetails) && item.advertiseExpenseDetails.suppliers === 'srm') {
              oldAdvertiseFlag = true;
              item.advertiseExpenseDetails = null;
              // 广告品费用清0
              returnVal.advertisingCost = 0;
            } else {
              item.advertiseExpenseDetails = null;
            }
            returnVal.advertiseExpenseDetails = {
              ...item.advertiseExpenseDetails,
              advertiseOrderDetails: item.advertiseExpenseDetails ? item.advertiseExpenseDetails.advertiseOrderDetails : []
            };
            returnVal.allsmartOrderVOList = item.allsmartOrderVOList;
            tableListData.push(returnVal);
          }
        });
        this.tableData = tableListData;
        this.loadTable();
      }
      if (oldAdvertiseFlag) {
        this.$confirm(this.$t('newApp.Attribute.DueTT'), this.$t('general.Hint'), {
          confirmButtonText: this.$t('btn.OK'),
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false,
          type: 'warning'
        }).then(() => {
        }).catch(() => {
        });
      }
      if (this.isShowProductLine()) {
        this.getProductLineList();
      }
      this.costTotal = this.editEchoData.marketActivity.totalCost;
      this.getExpenseDeptList(this.editEchoData.marketActivity.salerDeptCode, 1);// 获取费用归属部门列表
    } else {
      this.loadTable(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.activity-input ::v-deep .el-input .el-input__inner {
  text-align: center !important;
}
.costAscription {
  >.totalAmount {
    color: #3384FE;
    text-align: right;
    line-height: 44px;
  }

  .custom {
    font-size: 14px;

    >.red {
      color: #F53E48;
    }

    >.connect {
      color: #508DB4;
    }
  }

  >.buttonBar {
    &:after {
      content: "";
      display: block;
      clear: both;
    }

    >button {
      float: right;
    }
  }

  ::v-deep>.common_table {
    .vxe-table--footer-wrapper tr {
      >td {
        height: 48px;
        font-size: 16px;
        color: #424c57;
        font-weight: 400;

        >.vxe-cell {
          padding-left: 20px;
          padding-right: 0;
        }
      }

      >td+td {
        color: #14937b;

        >.vxe-cell {
          padding-left: 0;
        }
      }
    }
  }
}
</style>
